const domainActionWarningMessages = {
    add: 'By adding domains to Email Fraud Defense (EFD) you represent and warrant that you (1) own or (2) are licensed to use  each domain. You will indemnify and hold Proofpoint harmless for any losses or liabilities due to claims, actions or threats relating to your use of the domains with EFD. You irrevocably agree Proofpoint is entitled to rely on this disclaimer when you add domains to EFD.',
    changeType: 'When changing domain type from non-sending to sending, please allow 24 hours for data to populate.',
    remove: '', // will be added at a later time. don't have the legal text at the moment
};

export default domainActionWarningMessages;
